export default __webpack_public_path__ + "static/media/Cloetta-Logo-White.b62dd9b3.png";